import {
  language_item,
  logout_item,
  profile_item,
  support_item,
} from '../../../../../components/layout/ProfileDropdown';

export default {
  items: {
    [profile_item]: 'Profil',
    [language_item]: 'Schimbă limba',
    [support_item]: 'Suport',
    [logout_item]: 'Deconectare',
  },
};
